(function () {
    'use strict';

    angular.module("imApp").factory("consignmentLineService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 331,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 437,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
